import $ from 'jquery';

function calculateLineHeight($element) {
  let height = 0;
  const styles = [
    'display: inline !important;',
    'position: absolute !important;',
    'line-height: inherit !important;',
    'padding: 0 !important;',
    'visibility: hidden !important;',
    'opacity: 0 !important;'
  ];
  const $testEl = $('<span>&nbsp;</span>').attr('style', styles.join(''));

  $element.append($testEl);

  height = $testEl.height();

  $testEl.remove();

  return height;
}

export default ($element) => {
  const lineHeight = parseFloat($element.css('line-height'));

  return Number.isNaN(lineHeight) ? calculateLineHeight($element) : Math.ceil(lineHeight);
}
